import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { usePrevious } from './usePrevious.js';
/**
 * Same as `useSmartControlled` except for toggles like Checkbox
 * HTMLElements.
 */

var useSmartControlledToggle = function useSmartControlledToggle(defaultValue, propValue, onChangeProp) {
  var isControlled = propValue != null && onChangeProp != null; // Set up React state hook for this prop

  var _React$useState = React.useState(propValue !== undefined ? propValue : defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1]; // Remember previously seen propValue


  var prevPropValue = usePrevious(propValue); // Triggers onChangeProp AND updates state if user did not provide both value and onChange props

  var onChange = React.useCallback(function (event) {
    if (onChangeProp !== undefined) {
      onChangeProp(event);
    }

    if (!isControlled) {
      setState(function (value) {
        return !value;
      });
    }
  }, [onChangeProp, setState]); // Update state if passed propValue changes

  if (propValue !== prevPropValue && propValue !== state && propValue !== undefined) {
    setState(propValue);
  } // Don't use React.useEffect here as it delays updates too long, breaking e.g.
  // cursors in input fields (cursor jumps to end of text at each change)
  // React.useEffect(() => setState(propValue), [propValue]);
  // Return current state and function for updating it


  return [state, onChange];
};

export { useSmartControlledToggle };